import { createFileRoute } from '@tanstack/react-router';
import { useIsMobileShell } from '@/shared/mobile/useIsMobileShell';
import { UserAudit } from '@/features/auth/UserAudit';
import { MobileUserAudit } from '@/features/auth/mobile/MobileUserAudit';

export const Route = createFileRoute('/_app/user-audit')({ component: UserAuditRoute });

/** Selettore: audit utente mobile (MaeDesign) vs timeline desktop. */
function UserAuditRoute() {
  const isMobile = useIsMobileShell();
  return isMobile ? <MobileUserAudit /> : <UserAudit />;
}
